const COLLECTION_VISIBILITY = [
    {label: "🌐 Public", value: "guest", description : "🌐 Public : La collection n’a pas de restriction, tout le monde peut la voir."},
    {label: "👥 Membres", value: "public", description : "👥 Membres : La collection n’est visible que pour les membres inscrits sur Voissa."},
    {label: "⭕ Mon cercle", value: "friends", description : "⭕ Mon cercle : Seuls les membres de mon cercle pourront voir le contenu de la collection"},
    {label: "✅ Certifiés", value: "certified", description : "✅ Certifiés : Seulement les membres certifiés pourront voir le contenu de la collection"},
    {label: "🔒 Privé", value: "private", description : "🔒 Privé : Masquera votre collection aux autres membres à l'exception des modérateurs et administrateurs."}
];

export {
    COLLECTION_VISIBILITY
}